export default __webpack_public_path__ + "static/attributionWindow-20be864007787970159983116789e9a6.png";